import { apiRequest } from "../../index";

export const getHotelById = async (hotelId) => {
  return apiRequest(`/api/user/hotels/${hotelId}`, "GET");
};

export const getHotelActivities = async (hotelId) => {
  return apiRequest(`/api/user/hotels/activities/${hotelId}`, "GET");
};

export const getOngoingBooking = async () => {
  return apiRequest(`/api/user/hotels/ongoing/booking`, "GET");
};

export const getHotelOrders = async (bookingId, page = 1, limit = 10, status = "") => {
  const params = new URLSearchParams();
  // if (bookingId) {
  //   params.append('bookingId', bookingId);
  // }
  if (status) {
    params.append('status', status);
  }
  params.append('page', page);
  params.append('limit', limit);
  return apiRequest(`/api/user/hotels/orders/all?${params.toString()}`, "GET");
};

export const getAvailableRooms = async ({ hotelId, limit, checkInDate, checkOutDate, roomCapacity, status , page }) => {
  const params = new URLSearchParams({
    checkInDate,
    checkOutDate,
    roomCapacity,
    page,
    status,
    limit,
  });

  return apiRequest(`/api/user/hotels/rooms/${hotelId}?${params.toString()}`, "GET");
};

export const getBookingPrice = async (data) => {
  return apiRequest(`/api/user/hotels/booking/price`, "POST" , data);
};

export const bookHotel = async (data) => {
  return apiRequest(`/api/user/hotels/booking/checkout`, "POST", data);
}   

export const getAllBookings = async ({ page, limit }) => {
  return apiRequest(`/api/user/hotels/bookings/listing?page=${page}&limit=${limit}`, "GET");
};

export const getBookingDetail = async (bookingId) => {
  return apiRequest(`/api/user/hotels/bookings/detail/${bookingId}`, "GET");
};

export const getHotelMenu = async (hotelId) => {
  return apiRequest(`/api/user/hotels/menu/${hotelId}`, "GET");
};

export const getAllCategories = async (hotelId) => {
  return apiRequest(`/api/user/hotels/menu/category/${hotelId}`, "GET");
};

export const getCartPrice = async ({bookingId , items, hotelId, roomId}) => {
  return apiRequest(`/api/user/hotels/cart/price`, "POST" , { orderData : {bookingId , items, hotelId, roomId}});
};

export const getHotelCart = async ({ hotelId, bookingId, roomId }) => {
  const params = new URLSearchParams({ hotelId });
  if (bookingId) params.append('bookingId', bookingId);
  if (roomId) params.append('roomId', roomId);
  return apiRequest(`/api/user/hotels/cart/get?${params.toString()}`, "GET");
};

export const updateCartItemQuantity = async (data) => {
  return apiRequest(`/api/user/hotels/cart/update-quantity`, "POST", data);
};

export const placeOrder = async(formData)=>{
  return apiRequest(`/api/user/hotels/order/checkout`, "POST" , { orderData : {...formData}});
}

// Guest flow uses same endpoints (supports hotelId+roomId when bookingId omitted)